function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor( (total/1000) % 60 );
  const minutes = Math.floor( (total/1000/60) % 60 );
  const hours = Math.floor( (total/(1000*60*60)) % 24 );
  const days = Math.floor( total/(1000*60*60*24) );

  return {
    total,
    days,
    hours,
    minutes,
    seconds
  };
}

function pad(num) {
  return ("00" + num).slice(-2);
}

$(function() {
  $('[data-countdown-to]').each(function(i, el) {
    const end = ($(el).data('countdown-to'));
    const timeinterval = setInterval(updateTime, 1000);
    updateTime();

    function updateTime() {
      const t = getTimeRemaining(end);
      $(el).find('.days').text(t.days);
      $(el).find('.hours').text(pad(t.hours));
      $(el).find('.minutes').text(pad(t.minutes));
      $(el).find('.seconds').text(pad(t.seconds));
      if (t.total <= 0) {
        clearInterval(timeinterval);
      }
    }
  });  
});